/** Raw catalog: "Name|Brand" per line (brand optional) */
export const MEN_LINES = `
Bleu de Chanel|Chanel
Boss Bottled|Hugo Boss
Aventus|Creed
Fahrenheit|Dior
Lacoste Black|Lacoste
Acqua Di Gio|Armani
The One|Dolce & Gabbana
Legend|Montblanc
Stronger With You|Armani
Boss The Scent|Hugo Boss
Black XS L'Exces|Paco Rabanne
Eros|Versace
Ultra Male|Jean Paul Gaultier
Lacoste White|Lacoste
Voyage|Nautica
Dunhill Desire|Dunhill
Y|Yves Saint Laurent (YSL)
One Million Elixir|Paco Rabanne
One Million Lucky|Paco Rabanne
Sauvage|Dior
Azzaro Chrome|Azzaro
Le Male Elixir|Jean Paul Gaultier
The Most Wanted|Azzaro
212 Men NYC|Carolina Herrera
Marbelt Man|Lithioo
Silver Mountain Water|Creed
Phantom|Paco Rabanne
Invictus|Paco Rabanne
K|Dolce & Gabbana
Silver Scent|Jacques Bogart
`.trim();

export const WOMEN_LINES = `
Yara Candy|Lattafa
Moon Sparkle|Escada
Idôle|Lancôme
Vanilla 28|Kayali
Good Girl|Carolina Herrera
Escada Collection|Escada
La Nuit Trésor|Lancôme
Libre|Yves Saint Laurent (YSL)
Scandal|Jean Paul Gaultier
Roberto Cavalli|Roberto Cavalli
Modern Princess|Lanvin
Bare Vanilla|Victoria's Secret
Because It's You|Armani
Bombshell|Victoria's Secret
Agua Del Sol|Escada
Black Opium|Yves Saint Laurent (YSL)
Vanilla Candy Rock Sugar|Kayali
Sí Passione|Armani
Midnight Fantasy|Britney Spears
Signature|Montblanc
Private Show|Britney Spears
Goddess|Burberry
Black XS Potion|Paco Rabanne
Sí|Armani
Roses Vanille|Mancera
J'adore|Dior
La Vie Est Belle|Lancôme
Olympea|Paco Rabanne
Fantasy|Britney Spears
Burberry Her|Burberry
Very Sexy Now|Victoria's Secret
Love Is Heavenly|Victoria's Secret
Wanted Girl|Azzaro
Paris Hilton|Paris Hilton
Miss Dior Chérie|Dior
Katy Perry|Katy Perry
Icon|Rasasi
Voce Viva|Valentino
`.trim();

export const SPECIAL_LINES = `
Xerjoff|Xerjoff
Maghnawi|Arabian Oud
She Oud|Lithioo
Mukhalaat Maa El Thahab|Lithioo
Amber Desire|Lithioo
Musk Al Tahara|Lithioo
Musk Cherry|Lithioo
Black Afgano|Nasomatto
Seqmesk|Lithioo
Al Fares Al Asmar|Lithioo
Silk Musk|Lithioo
Kalemat|Arabian Oud
Black Orchid|Tom Ford
Strawberry Musk|Lithioo
Al Ghareeb|Lithioo
Bianco Latte|Lithioo
Kalan|Parfums de Marly
Jasphil Chill|Lithioo
Layton|Parfums de Marly
Musk Al Tahara Pomegranate|Lithioo
Tuxedo|Yves Saint Laurent (YSL)
Sweet Musk|Lithioo
Hersh Laheeb|Lithioo
Khamrah|Lattafa
Percival|Parfums de Marly
Deja Vu|Gissah
Stronger With You Amber|Armani
Alf Leila Wa Leila (1001 Nights)|Lithioo
Hacivat|Nishane
Al Hajar Al Aswad (The Black Stone)|Lithioo
Imperial Valley|Gissah
Erba Pura|Sospiro
Amber Malaki|Chopard
Daarej|Rasasi
Accento|Sospiro
Historic Sahara|Afnan
Special Nisho|Nishane
Megamare|Orto Parisi
Pomegranate Musk|Lithioo
Sir Al Khulood|Lattafa
Shaghaf|Swiss Arabian
Baccarat Rouge 540|Maison Francis Kurkdjian
Gobar El Thahab|Sahara
Arabians Tonka|Montale
Ana Abiyedh|Lattafa
Manifesto|Yves Saint Laurent (YSL)
`.trim();

export const PRODUCT_SECTIONS = [
  { id: 'men' },
  { id: 'women' },
  { id: 'special' },
  { id: 'new-diverse' },
  { id: 'original' },
];
